// extracted by mini-css-extract-plugin
module.exports = {"wrap":"EditAdvancedProjectContainer_wrap__1GucM","title":"EditAdvancedProjectContainer_title__2EKyE","loader":"EditAdvancedProjectContainer_loader__3t5E7"};